import React from "react";

const features = [
  {
    icon: "assets/img/icon-target.png",
    text: "Gracias a nuestra IA, la búsqueda, filtrado y selección de candidatos es hasta un 60% más rápida que con los métodos tradicionales.",
    alt: "Target con IA",
  },
  {
    icon: "assets/img/icon-video-ai.png",
    text: "Publicación de vacantes por medio de videos creados con IA.",
    alt: "Publicaciones con IA",
  },
  {
    icon: "assets/img/icon-exclusive.png",
    text: "Material Exclusivo para tu empresa y tus vacantes.",
    alt: "Material exclusivo",
  },
  {
    icon: "assets/img/icon-faster.png",
    text: "Atención Rápida y eficaz al 100% de los candidatos postulados.",
    alt: "Atención rápida",
  },
  {
    icon: "assets/img/icon-filterAI.png",
    text: "Filtros inteligentes que analizan experiencia y compatibilidad en segundos.",
    alt: "Filtros inteligentes",
  },
  {
    icon: "assets/img/icon-traffic-website.png",
    text: "Generamos trafico de candidatos para tener un mayor alcance. ",
    alt: "Generación de tráfico",
  },
  {
    icon: "assets/img/icon-guarantee-certificate.png",
    text: "Garantizamos tus posiciones.",
    alt: "Garantia",
  },
];

const Features = () => {
  return (
     <div className="overflow-hidden">
        <section id="Servicios" className="about-us ptb-100 background-shape-img">
          <div className="container">
            <div className="row align-items-center justify-content-between">
              <div className="col-md-7">
                <div className="about-content-left section-heading">
                  <h2>
                    Contrata Más Rápido, Mejor Calidad <br />
                    
                  </h2>
                {features.map((feature, index) => (
                  <div className="single-feature mb-4 " key={index}>
                    <div className="icon-box-wrap d-flex align-items-center mb-2">
                      <div className="mr-3 icon-box icon-filter">
                        <img
                          src={feature.icon}
                          alt={feature.alt}
                          className="img-fluid"
                        />
                      </div>
                      <p className="mb-0">{feature.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="col-md-5">
              <div className="about-content-right text-center">
                <img
                  src="assets/img/hands.png"
                  alt="Equipo colaborando"
                  className="img-fluid"
                  style={{ maxHeight: "350px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Features;
